import { FC } from "react";

import { Box, Heading, useMultiStyleConfig } from "@chakra-ui/react";

import { LayoutContent } from "@modules/layout";

const PageHeader: FC<{ children?: any }> = ({ children }) => {
  const styles = useMultiStyleConfig("PageHeader", {});
  return (
    <Box sx={styles.headerContainer}>
      <LayoutContent>
        <Heading sx={styles.headerText}>{children}</Heading>
      </LayoutContent>
    </Box>
  );
};
export default PageHeader;
